import React, { useContext } from "react";
import {
  Select,
  FormControl,
  MenuItem,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import useStyles from "./styles";
import { MatchContext } from "../../context";
import { SET_DATA } from "../../reduce/actionTypes";
import useTrackEvent from "../../utils/hooks/use-track-app-event";
import { APP_INSIGHTS_EVENTS } from "../../constants";

export default function GraphSelect({
  handleSensorChange,
  value,
  dataId,
}): JSX.Element {
  const classes = useStyles();
  const trackEvent = useTrackEvent();
  const { state, dispatch } = useContext(MatchContext);

  const handleChangeBestDays = () => {
    trackEvent(APP_INSIGHTS_EVENTS.CHANGE_BEST_DAYS, {
      value: !state.graphsBestDays[dataId] ? "show" : "hide",
      graph: dataId,
    });
    dispatch({
      type: SET_DATA,
      payload: {
        graphsBestDays: {
          ...state.graphsBestDays,
          [dataId]: !state.graphsBestDays[dataId],
        },
      },
    });
  };

  const handleChangeBookmarks = () => {
    trackEvent(APP_INSIGHTS_EVENTS.CHANGE_BOOKMARKS, {
      value: !state.graphsBookmarks[dataId] ? "show" : "hide",
      graph: dataId,
    });
    dispatch({
      type: SET_DATA,
      payload: {
        graphsBookmarks: {
          ...state.graphsBookmarks,
          [dataId]: !state.graphsBookmarks[dataId],
        },
      },
    });
  };

  return (
    <React.Fragment>
      <Grid item container xs={12} className={classes.container}>
        <Grid item container xs={7}>
          <FormControl className={classes.formControl}>
            <Select
              id={`${dataId}-sensor-select`}
              name={dataId}
              value={value}
              displayEmpty
              onChange={handleSensorChange}
            >
              <MenuItem value="">
                <em>---</em>
              </MenuItem>
              {state.sensorsList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item container xs={5}>
          <Grid
            item
            container
            xs={6}
            justifyContent="flex-end"
            alignContent="center"
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.graphsBookmarks[dataId]}
                    onChange={handleChangeBookmarks}
                    color="primary"
                    className={classes.checkBox}
                  />
                }
                label="Bookmarks"
                name="bookmarks-checked"
              />
            </FormGroup>
          </Grid>
          <Grid
            item
            container
            xs={6}
            justifyContent="flex-end"
            alignContent="center"
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.graphsBestDays[dataId]}
                    onChange={handleChangeBestDays}
                    color="primary"
                    className={classes.checkBox}
                  />
                }
                title="Best performing day is defined using maximum Eff_TPH parameter value"
                label="Best days"
                name="best-day-checked"
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
